import { logger } from 'lib/logger';
import { referralProgramReferrerLanding } from 'reactApp/appHelpers/featuresHelpers/features/referralProgram';
import { ROOT_FOLDER_ID } from 'reactApp/constants/magicIdentificators';
import type { QueryParams } from 'reactApp/modules//settings/settings.types';
import { EStorageType } from 'reactApp/modules//storage/storage.types';
import { loadBillingDataIfNotLoaded } from 'reactApp/modules/billingData/billingData.provider';
import { BillingDataReferralSelectors } from 'reactApp/modules/billingData/billingData.referral.selectors';
import { routeChangeSuccess } from 'reactApp/modules/router/router.module';
import { SettingsSelectors } from 'reactApp/modules/settings/settings.selectors';
import { startSubscriptionsPageRequest } from 'reactApp/modules/subscriptions/subscriptions.module';
import { renderReferralModal } from 'reactApp/ui/ReferralProgram/ReferralModal/ReferralModal.helpers';
import { captureException } from 'reactApp/utils/tracer';
import { cancel, put, select, takeEvery } from 'redux-saga/effects';

function* handleSubscriptionsPageStart() {
    try {
        yield put(
            routeChangeSuccess({
                id: ROOT_FOLDER_ID,
                storage: EStorageType.subscriptions,
                params: {},
                __isFolder: true,
                url: '',
                __parent: '',
            })
        );

        const { referral }: QueryParams = yield select(SettingsSelectors.getQueryParams);
        // tempexp_18086-start
        if (referralProgramReferrerLanding || referral) {
            yield loadBillingDataIfNotLoaded();
        }
        if (referral) {
            const referralQuota = yield select(BillingDataReferralSelectors.getReferralCommonQuota);
            const referralList = yield select(BillingDataReferralSelectors.sortReferralsByExpires);

            yield renderReferralModal({
                quota: referralQuota,
                list: referralList,
                isReturn: false,
            });
        }
        // tempexp_18086-end
    } catch (error) {
        logger.error(error);
        captureException(error);
        yield cancel();
    }
}

export function* watchSubscriptionsRoot() {
    yield takeEvery(startSubscriptionsPageRequest.toString(), handleSubscriptionsPageStart);
}
